import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { isTotemAccessEnabled } from "./lib/totemAccess";
import CardPage from "./components/CardPage";
import EventAvatarAiPage from "./components/EventAvatarAiPage";
import HomePage from "./components/HomePage";
import ManageCardPage from "./components/ManageCardPage";
import PreviewPage from "./components/PreviewPage";
import PrivacyPage from "./components/PrivacyPage";
import TermsPage from "./components/TermsPage";
import ReactGA from "react-ga4";
ReactGA.initialize(process.env.REACT_APP_GA_CARDS_CODE, {
  debug: process.env.REACT_APP_DEV_MODE === "true",
});
ReactGA.pageview(window.location.pathname + window.location.search);

// The totem kiosk page is hidden from public navigation: it renders only when
// the URL carries `?totem=1`, otherwise we send visitors back to the homepage.
function RequireTotemAccess({ children }) {
  const location = useLocation();

  if (!isTotemAccessEnabled(location.search)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route
          path="/totem"
          element={
            <RequireTotemAccess>
              <EventAvatarAiPage />
            </RequireTotemAccess>
          }
        />
        <Route
          path="/evento/avatar-ai"
          element={
            <RequireTotemAccess>
              <EventAvatarAiPage />
            </RequireTotemAccess>
          }
        />
        <Route
          path="/totem/avatar-ai"
          element={
            <RequireTotemAccess>
              <EventAvatarAiPage />
            </RequireTotemAccess>
          }
        />
        <Route path="/gestisci" element={<ManageCardPage />} />
        <Route path="/anteprima" element={<PreviewPage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
        <Route path="/termini-e-condizioni" element={<TermsPage />} />
        <Route path="/:orgName/:personFullName" element={<CardPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
